import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './__root';

interface RedirectSearch {
  to: string;
}

export const redirectRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/redirect',
  validateSearch: (raw: Record<string, unknown>): RedirectSearch => ({
    to: typeof raw.to === 'string' ? raw.to : '',
  }),
  component: RedirectPage,
});

function RedirectPage() {
  const { to } = redirectRoute.useSearch();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <p className="text-muted-foreground mb-4">Redirecting to the app...</p>
        <a href={to} className="text-primary underline">
          Click here if not redirected
        </a>
      </div>
    </div>
  );
}
